import RoomWall from './RoomWall';

export default RoomWall;
